import checkYellow from '@/assets/icons/check-yellow.svg'
import EnergyIcon from '@/assets/icons/energy-light.svg'

import { Button, ButtonText, CheckIcon, CompletedButton } from './styles'

interface MissionButtonProps {
  onClick: () => void
  isCompleted: boolean
}

export default function MissionButton({ onClick, isCompleted }: MissionButtonProps) {
  if (isCompleted) {
    return (
      <CompletedButton disabled>
        <CheckIcon src={checkYellow} alt='' />
      </CompletedButton>
    )
  }

  return (
    <Button onClick={onClick}>
      <img src={EnergyIcon} alt='' width={24} height={24} />
      <ButtonText>받기</ButtonText>
    </Button>
  )
}
